import { Observable } from 'rxjs';

import { DeviceSetCreateParams, DeviceSets } from '../models/device-set.model';

export abstract class DeviceSetUsecase {
  abstract get deviceSets$(): Observable<DeviceSets>;

  abstract reload(): void;
  abstract createDeviceSet(params: DeviceSetCreateParams): Observable<never>;
  abstract deleteDeviceSet(deviceSetId: string): Observable<never>;
}
